	export enum PureToneCategoryEnum {
		Normal = 1,
		Sensorineural = 2,
		Conductive = 3,
		Mixed = 4,
		Unspecified = 5,
		Sensorineural_w_HA = 6,
		Sensorineural_n_HA = 7
	}
